import { Notification } from "@contexts/Notifications/types";

export const getNotifications = async (): Promise<Notification[]> => {
  const response = await fetch("/notifications");

  if (!response.ok) {
    throw new Error("Erro ao buscar notificações");
  }

  const data = (await response.json()) as Notification[];
  return data;
};

export const markNotificationAsRead = async (
  notificationId: string,
): Promise<void> => {
  const response = await fetch(`/notifications/${notificationId}/read`, {
    method: "PATCH",
  });

  if (!response.ok) {
    throw new Error("Erro ao marcar notificação como lida");
  }
};
